'use client';

import type { PropsWithChildren } from 'react';
import { useCallback } from 'react';
import { useGetAccountForPrimaryNavPanelQuery } from '@frameio/primary-nav/gql';
import { useIsQuickSearchV2Enabled } from '@frameio/search/hooks';
import { useActiveAccountId } from '@frameio/shared/contexts';
import { useIsMatchingClientName } from '@frameio/shared/contexts/ClientNameContext';
import { HeaderPanel } from './HeaderPanel';

export const WorkspacesHeader = (props: PropsWithChildren) => {
  const {
    isEnabled: isQuickSearchV2Enabled,
    isLoading: isQuickSearchV2CheckLoading,
  } = useIsQuickSearchV2Enabled();
  const accountId = useActiveAccountId();
  const { data, loading } = useGetAccountForPrimaryNavPanelQuery({
    fetchPolicy: 'cache-only',
    skip: !accountId,
    variables: {
      accountId,
    },
  });
  const isWebClient = useIsMatchingClientName('web');

  const isLoading = isQuickSearchV2CheckLoading || loading || !data;
  const isLimitedToOneWorkspace =
    isLoading ||
    data.account?.subscription?.limitedResources?.workspaces?.limit53 === 1;

  const shouldHide = useCallback(() => {
    if (!isWebClient) return false;
    return isQuickSearchV2Enabled ? isLoading : isLimitedToOneWorkspace;
  }, [isWebClient, isQuickSearchV2Enabled, isLoading, isLimitedToOneWorkspace]);

  return (
    <HeaderPanel
      $hidden={shouldHide()}
      $isWebClient={isWebClient}
      data-testid="sections-header"
    >
      {props.children}
    </HeaderPanel>
  );
};
